import { useReviewerContext } from '../context/reviewer/ReviewerProvider'
import { useReviewersContext } from '../context/reviewers/ReviewersProvider'
import { REVIEWERS_ACTIONS } from '../context/reviewers/REVIEWERS_ACTIONS.js'
import ReviewerService from '../services/ReviewerService'
import { REVIEWER_ACTIONS } from '../context/reviewer/REVIEWER_ACTIONS'
import { useSearchParams } from 'react-router-dom'

export default function useReviewersActions() {
  const [searchParams] = useSearchParams()
  const { reviewersDispatch } = useReviewersContext()
  const { reviewerDispatch } = useReviewerContext()

  async function getReviewers() {
    try {
      reviewersDispatch({
        type: REVIEWERS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await ReviewerService.getReviewers(
        searchParams.toString(),
      )
      reviewersDispatch({
        type: REVIEWERS_ACTIONS.SET_REVIEWERS,
        payload: {
          reviewers: data.reviewers,
          pagination: {
            links: data.links,
            current_page: data.current_page,
            first_page: data.first_page,
            last_page: data.last_page,
          },
        },
      })
    } catch (error) {
      throw error
    } finally {
      reviewersDispatch({
        type: REVIEWERS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }
  async function getReviewer(reviewerId) {
    try {
      reviewerDispatch({
        type: REVIEWER_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await ReviewerService.getReviewer(reviewerId)
      reviewerDispatch({
        type: REVIEWER_ACTIONS.SET_REVIEWER,
        payload: {
          reviewer: data.reviewer,
        },
      })

      return data.reviewer
    } catch (error) {
      throw error
    } finally {
      reviewerDispatch({
        type: REVIEWER_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }
  async function getReviewersStatistics() {
    try {
      const { data } = await ReviewerService.getReviewersStatistics()
      return data.reviews
    } catch (error) {
      throw error
    }
  }
  return {
    getReviewers,
    getReviewer,
    getReviewersStatistics,
  }
}
